export class IntegralRiskData {
  combinedIntegralId: number;
  combinedIntegralName: string;
}
